import React, { useState, useEffect } from 'react';

function ResidentList() {
  const [residents, setResidents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    email: '',
    emergency_contact_name: '',
    emergency_contact_phone: '',
    line_user_id: ''
  });

  // 住民一覧を取得
  const fetchResidents = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${API_URL}/api/residents`);
      const data = await response.json();
      if (data.success) {
        setResidents(data.residents);
      }
    } catch (error) {
      console.error('データ取得エラー:', error);
      alert('住民データの取得に失敗しました');
    }
  };

  useEffect(() => {
    fetchResidents();
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const url = editingId 
        ? `${API_URL}/api/residents/${editingId}`
        : `${API_URL}/api/residents`;
      
      const method = editingId ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (data.success) {
        alert(data.message);
        setFormData({
          name: '',
          phone: '',
          address: '',
          email: '',
          emergency_contact_name: '',
          emergency_contact_phone: ''
        });
        setShowForm(false);
        setEditingId(null);
        fetchResidents();
      } else {
        alert('エラー: ' + data.message);
      }
    } catch (error) {
      console.error('送信エラー:', error);
      alert('データの送信に失敗しました');
    }
  };

  const handleEdit = (resident) => {
    setFormData({
      name: resident.name,
      phone: resident.phone,
      address: resident.address,
      email: resident.email || '',
      emergency_contact_name: resident.emergency_contact_name || '',
      emergency_contact_phone: resident.emergency_contact_phone || '',
      line_user_id: resident.line_user_id || ''
    });
    setEditingId(resident.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('本当に削除しますか？')) {
      return;
    }
    
    try {
      const response = await fetch(`http://localhost:5000/api/residents/${id}`, {
        method: 'DELETE',
      });
      
      const data = await response.json();
      
      if (data.success) {
        alert(data.message);
        fetchResidents();
      } else {
        alert('エラー: ' + data.message);
      }
    } catch (error) {
      console.error('削除エラー:', error);
      alert('削除に失敗しました');
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({
      name: '',
      phone: '',
      address: '',
      email: '',
      emergency_contact_name: '',
      emergency_contact_phone: '',
      line_user_id: ''
    });
  };

  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h2 style={{ margin: 0 }}>住民一覧（登録数: {residents.length}人）</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            padding: '10px 20px',
            backgroundColor: showForm ? '#999' : '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {showForm ? 'キャンセル' : '+ 新規登録'}
        </button>
      </div>

      {/* 登録・編集フォーム */}
      {showForm && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '30px', 
          borderRadius: '10px',
          marginBottom: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <h3>{editingId ? '住民情報編集' : '住民情報登録'}</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  氏名 *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  電話番号 *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  placeholder="090-1234-5678"
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  住所 *
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  メールアドレス
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  緊急連絡先（氏名）
                </label>
                <input
                  type="text"
                  name="emergency_contact_name"
                  value={formData.emergency_contact_name}
                  onChange={handleInputChange}
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  緊急連絡先（電話番号）
                </label>
                <input
                  type="tel"
                  name="emergency_contact_phone"
                  value={formData.emergency_contact_phone}
                  onChange={handleInputChange}
                  placeholder="090-1234-5678"
                  style={{ 
                    width: '100%', 
                    padding: '10px', 
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

	    <div style={{ gridColumn: '1 / -1' }}>
 	      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                LINE User ID
	      </label>
	      <input
		type="text"
                name="line_user_id"
                value={formData.line_user_id}
                onChange={handleInputChange}
                placeholder="友だち追加後に取得したUser IDを入力"
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  boxSizing: 'border-box'
                }}
             />
             <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
               ※LINE公式アカウントを友だち追加後、Botから送られるUser IDをコピーしてください
            </p>
           </div>

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
              <button
                type="submit"
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                {editingId ? '更新' : '登録'}
              </button>
              
              <button
                type="button"
                onClick={handleCancel}
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#999',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                キャンセル
              </button>
            </div>
          </form>
        </div>
      )}

      {/* 住民一覧テーブル */}
      <div style={{ 
        backgroundColor: 'white', 
        borderRadius: '10px',
        overflow: 'hidden',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        {residents.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
            登録されている住民はいません
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>氏名</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>電話番号</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>住所</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>メール</th>
                <th style={{ padding: '15px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>LINE</th>
                <th style={{ padding: '15px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {residents.map((resident) => (
                <tr key={resident.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '15px' }}>{resident.name}</td>
                  <td style={{ padding: '15px' }}>{resident.phone}</td>
                  <td style={{ padding: '15px' }}>{resident.address}</td>
                  <td style={{ padding: '15px' }}>{resident.email || '-'}</td>
		  <td style={{ padding: '15px', textAlign: 'center' }}>
                    {resident.line_user_id ? (
                      <span style={{ color: '#4CAF50', fontWeight: 'bold' }}>✓ 登録済</span>
                    ) : (
                      <span style={{ color: '#999' }}>未登録</span>
                    )}
                  </td>
                  <td style={{ padding: '15px', textAlign: 'center' }}>
                    <button 
                      onClick={() => handleEdit(resident)}
                      style={{ 
                        marginRight: '10px',
                        padding: '5px 15px',
                        backgroundColor: '#2196F3',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      編集
                    </button>
                    <button 
                      onClick={() => handleDelete(resident.id)}
                      style={{ 
                        padding: '5px 15px',
                        backgroundColor: '#f44336',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ResidentList;
